import Request from './request.js'
export default class {
  /**
   * 获取所有数据
   * @param setSelections
   */
  async getOnSiteEvidence () {
    if (this.caseId) {
      await Request.getOnSiteEvidence.call(this, this.caseId)
    }
  }
  /**
   * 显示数据
   * @param setSelections
   */
  showOnSiteEvidence (result) {
    if (result.code === '0') {
      this.data = result.data
    }
  }
  setSelections (setSelections) {
    this.selections[this.activeName] = setSelections
  }
  /**
   * 点击上传，打开文件选择
   */
  openFilesChoose (name) {
    this.$refs.fileInput.click()
  }
  /**
   * choosedFiles
   */
  choosedFiles (ev) {
    // 记录文件s
    this.files = ev.target.files
    // 循环初始化新名字
    for (let i = 0; i < this.files.length; i++) {
      this.rename.newFileName[i] = this.files[i].name
    }
    // 显示重命名dialog
    // this.rename.visible = true
    this.methods('uploadStart')
  }
  uploadStart () {
    this.rename.visible = false
    console.log(this.rename.newFileName, '有没有写')
    this.uploadLoading = true
    setTimeout(() => {
      Request.uploadFiles.call(this, this.files, this.rename.newFileName, this.activeName)
    }, 2000)
  }
  /**
   * 上传结果
   * @param result
   */
  uploadResult (result) {
    if (result.code === '0') {
      this.$message.success('上传成功')
      this.$refs.fileInput.value = ''
      // 卷宗则重新查询
      // this.methods('getOnSiteEvidence')
      // 灰名单处理
      for (let item in this.rename.newFileName) {
        this.data[this.activeName].push({
          fileUrl: window.IMG_SERVER + this.rename.newFileName[item],
          // fileName: this.rename.newFileName[item],
          fileName: this.rename.newFileName[item],
          uploadTime: new Date().getTime()
        })
      }
    } else {
      this.$message.error(result.message)
    }
    this.uploadLoading = false
    // 这里应该清理rename
    this.rename.newFileName = {}
  }
  /**
   * 下载文件
   * @param name 模块名
   */
  downloadFiles (name) {
    let length = this.selections[name].length
    if (length > 0) {
      for (let i = 0; i < length; i++) {
        let a = document.createElement('a') // 创建a标签
        let e = document.createEvent('MouseEvents') // 创建鼠标事件对象
        e.initEvent('click', false, false) // 初始化事件对象
        a.target = '_blank'
        a.href = this.selections[name][i].fileUrl // 设置下载地址
        a.dispatchEvent(e) // 给指定的元素，执行事件click事件
      }
    } else {
      this.$message.warning('请至少选择一个文件')
    }
  }
  /**
   * 删除文件
   * @param name
   */
  deleteFiles (name) {
  }
  /**
   * 确定处理
   */
  dealBlackSubmit () {
    if (this.carBlacklistId) {
      Request.dealCarBlack.call(this, this.carBlacklistId, this.dodgingTollId, this.data)
    } else if (this.manBlacklistId) {
      Request.dealManBlack.call(this, this.manBlacklistId, this.dodgingTollId, this.data)
    } else {
      this.$message.warning('未知黑名单类型')
    }
  }
  /**
   * 处理结果
   * @param result
   */
  dealResult (result) {
    if (result.code === '0') {
      this.$message.success('处理成功')
      this.$emit('dealSuccess')
    } else {
      // this.$message.error(result.message)
    }
  }
}
